<ng-container *ngIf="isCreateModalMode; else pageDetailTemplate">
  <div class="create-servicenumber-modal" [testId]="'servicenumber-create-modal'">
    <div class="create-modal-header">
      <h2>{{ 'servicenumber.add-title' | i18n }}</h2>
      <button nz-button nzType="link" class="create-modal-close" (click)="goBack()" [testId]="'servicenumber-create-close'">
        <nz-icon nzType="close" />
      </button>
    </div>

    <div class="create-modal-body">
      <form nz-form *ngIf="basicForm" [formGroup]="basicForm" class="create-modal-form" [testId]="'servicenumber-create-form'">
        <section class="create-section">
          <h3>{{ 'servicenumber.basic-info' | i18n }}</h3>

          <div class="create-field">
            <label>{{ 'servicenumber.name' | i18n }} <span class="required-mark">*</span></label>
            <input
              nz-input
              formControlName="name"
              [placeholder]="'servicenumber.name-placeholder' | i18n"
              [testId]="'servicenumber-create-name'"
            />
          </div>

          <div class="create-field">
            <label>{{ 'servicenumber.type' | i18n }} <span class="required-mark">*</span></label>
            <nz-select
              formControlName="type"
              class="create-type-select"
              (ngModelChange)="onTypeChange($event)"
              [testId]="'servicenumber-create-type'"
            >
              <nz-option
                *ngFor="let option of filteredTypeOptions; trackBy: trackByValue"
                [nzValue]="option.value"
                [nzLabel]="option.label"
              />
            </nz-select>
          </div>

          <div class="create-field" *ngIf="basicForm?.get('type')?.value === 'Professional'">
            <label>{{ 'servicenumber.open-type' | i18n }} <span class="required-mark">*</span></label>
            <nz-select
              formControlName="openType"
              class="create-type-select"
              [nzPlaceHolder]="'servicenumber.open-type-placeholder' | i18n"
              [nzDisabled]="isOpenTypeDisabled"
              [testId]="'servicenumber-create-open-type'"
            >
              <nz-option *ngFor="let option of openTypeOptions; trackBy: trackByValue" [nzValue]="option.value" [nzLabel]="option.label" />
            </nz-select>
          </div>

          <div class="create-field">
            <label>{{ 'common.description' | i18n }} <span class="required-mark">*</span></label>
            <textarea
              nz-input
              formControlName="description"
              [placeholder]="'common.description-placeholder' | i18n"
              [nzAutosize]="{ minRows: 2, maxRows: 2 }"
              [testId]="'servicenumber-create-description'"
            ></textarea>
          </div>

          <div class="create-field avatar-field">
            <label>{{ 'servicenumber.avatar' | i18n }} <span class="required-mark">*</span></label>
            <div class="create-avatar-row">
              <div class="create-avatar-preview" (click)="showAvatarUploadModal()">
                <img
                  *ngIf="basicForm?.get('avatarUrl')?.value; else avatarPlaceholder"
                  [src]="basicForm.get('avatarUrl')?.value"
                  class="avatar-preview-image"
                />
                <ng-template #avatarPlaceholder>
                  <div class="avatar-placeholder"><i nz-icon nzType="user"></i></div>
                </ng-template>
              </div>
              <button
                nz-button
                nzType="default"
                type="button"
                class="upload-avatar-btn"
                (click)="showAvatarUploadModal()"
                testId="servicenumber-detail-upload-avatar-button"
              >
                {{ 'servicenumber.upload-avatar' | i18n }}
              </button>
            </div>
          </div>
        </section>
      </form>

      <servicenumber-member
        [serviceNumberId]="serviceNumberId"
        [isAddSN]="true"
        [inlineAddMode]="true"
        [tenantId]="tenantId"
        [tenantType]="tenantType"
        (membersChange)="handleMembersChange($event)"
        [testId]="'servicenumber-create-member-component'"
      />
    </div>

    <div class="create-modal-footer">
      <button nz-button nzType="default" (click)="goBack()" [testId]="'servicenumber-create-cancel'">{{ 'common.cancel' | i18n }}</button>
      <button nz-button nzType="primary" (click)="saveServiceNumber()" [nzLoading]="submitting" [testId]="'servicenumber-create-submit'">
        {{ 'servicenumber.add-title' | i18n }}
      </button>
    </div>
  </div>
</ng-container>

<ng-template #pageDetailTemplate>
  <div class="servicenumber-detail-container" [testId]="'servicenumber-detail-container'">
    <!-- 修改页面标题部分，添加面包屑导航 -->
    <div class="page-header" [testId]="'servicenumber-detail-page-header'">
      <div class="header-content" [testId]="'servicenumber-detail-header-content'">
        <div class="header-back-row" [testId]="'servicenumber-detail-left-section'">
          <button nz-button nzType="link" class="back-link-button" (click)="goBack()" [testId]="'servicenumber-detail-back-button'">
            <span class="back-link-content">
              <nz-icon nzType="arrow-left" [testId]="'servicenumber-detail-back-icon'" />
              <span>{{ 'common.back-to-list' | i18n }}</span>
            </span>
          </button>
        </div>
        <div class="header-main-row" [testId]="'servicenumber-detail-main-row'">
          <div *ngIf="isAdd; else serviceNumberInfo" class="header-create-state" [testId]="'servicenumber-detail-add-title'">
            <h2>{{ 'servicenumber.add-title' | i18n }}</h2>
          </div>
          <ng-template #serviceNumberInfo>
            <div class="center-section" [testId]="'servicenumber-detail-center-section'">
              <div class="servicenumber-avatar" [testId]="'servicenumber-detail-avatar-container'">
                <nz-avatar
                  [nzSrc]="avatarUrl"
                  [nzSize]="64"
                  nzIcon="user"
                  (click)="openImageViewer(avatarUrl)"
                  [testId]="'servicenumber-detail-avatar'"
                />
                <div class="avatar-upload" [testId]="'servicenumber-detail-avatar-upload'">
                  <button
                    nz-button
                    nzType="link"
                    nzSize="small"
                    (click)="showAvatarUploadModal()"
                    [testId]="'servicenumber-detail-avatar-upload-button'"
                  >
                    <nz-icon nzType="edit" nzTheme="outline" [testId]="'servicenumber-detail-avatar-upload-icon'" />
                  </button>
                </div>
              </div>
              <div class="servicenumber-info" [testId]="'servicenumber-detail-info'">
                <nz-tag [nzColor]="getServiceNumberTypeColor(serviceNumberData?.type)" [testId]="'servicenumber-detail-type-tag'">
                  {{ getServiceNumberTypeLabel(serviceNumberData?.type) }}
                </nz-tag>
                <h2 [testId]="'servicenumber-detail-name'">{{ serviceNumberName }}</h2>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- 加载中 -->
    <nz-spin [nzSpinning]="loading" [nzTip]="'common.loading' | i18n">
      <!-- 内容区域 -->
      <div class="detail-content" [class.mobile-mask-active]="showMobileDesktopPrompt" [testId]="'servicenumber-detail-content'">
        <nz-tabset
          class="servicenumber-detail-tabs"
          [testId]="'servicenumber-detail-tabset'"
          [nzSelectedIndex]="selectedTabIndex"
          (nzSelectChange)="onTabChange($event.index ?? 0)"
          [nzAnimated]="false"
        >
          <!-- 基础信息标签页 -->
          <nz-tab [nzTitle]="basicInfoTitle" [testId]="'servicenumber-detail-basic-tab'">
            <ng-template #basicInfoTitle>
              <i nz-icon nzType="info-circle" nzTheme="outline" [testId]="'basic-info-icon'"></i> {{ 'servicenumber.basic-info' | i18n }}
            </ng-template>
            <div class="basic-info-page" [testId]="'servicenumber-detail-basic-page'">
              <form
                nz-form
                nzLayout="vertical"
                *ngIf="basicForm"
                [formGroup]="basicForm"
                class="form-container basic-info-form"
                [testId]="'servicenumber-detail-form'"
              >
                <nz-card class="detail-surface-card basic-info-card">
                  <!-- 添加基础信息头部 -->
                  <div class="card-header">
                    <div class="card-heading">
                      <h3 class="page-title">{{ 'servicenumber.basic-info' | i18n }}</h3>
                    </div>
                    <div class="card-actions page-actions">
                      <button
                        nz-button
                        nzType="primary"
                        class="save-btn"
                        (click)="saveServiceNumber()"
                        [nzLoading]="submitting"
                        testId="servicenumber-detail-save-button"
                      >
                        <i nz-icon nzType="save" [testId]="'detail-save-icon'"></i>{{ 'common.save' | i18n }}
                      </button>
                      <!-- 启用/禁用服务号按钮（仅编辑模式可见） -->
                      <button
                        nz-button
                        nzType="default"
                        *ngIf="shouldShowEnableButton()"
                        class="status-action-btn enable-btn"
                        (click)="enableServiceNumber()"
                        [nzLoading]="loading"
                        nz-tooltip
                        [nzTooltipTitle]="'servicenumber.status.enable' | i18n"
                        [testId]="'servicenumber-detail-enable-button'"
                      >
                        <nz-icon nzType="check-circle" nzTheme="outline" /> {{ 'servicenumber.status.enable' | i18n }}
                      </button>
                      <button
                        nz-button
                        nzType="default"
                        *ngIf="shouldShowDisableButton()"
                        class="status-action-btn disable-btn"
                        (click)="disableServiceNumber()"
                        [nzLoading]="loading"
                        nz-tooltip
                        [nzTooltipTitle]="'servicenumber.status.disable' | i18n"
                        [testId]="'servicenumber-detail-disable-button'"
                      >
                        <nz-icon nzType="close-circle" nzTheme="outline" /> {{ 'servicenumber.status.disable' | i18n }}
                      </button>
                    </div>
                  </div>

                  <div nz-row [nzGutter]="24" [testId]="'servicenumber-detail-form-row'">
                    <div nz-col [nzXs]="24" [nzSm]="12" [testId]="'servicenumber-detail-name-col'">
                      <nz-form-item [testId]="'servicenumber-name-form-item'">
                        <nz-form-label nzRequired nzFor="name" [testId]="'servicenumber-detail-name-label'">{{
                          'servicenumber.name' | i18n
                        }}</nz-form-label>
                        <nz-form-control [nzErrorTip]="'servicenumber.name-required' | i18n" [testId]="'servicenumber-name-control'">
                          <input
                            nz-input
                            formControlName="name"
                            id="name"
                            [placeholder]="'servicenumber.name-placeholder' | i18n"
                            [testId]="'servicenumber-detail-name-input'"
                          />
                        </nz-form-control>
                      </nz-form-item>
                    </div>

                    <div nz-col [nzXs]="24" [nzSm]="12">
                      <nz-form-item [testId]="'servicenumber-type-form-item'">
                        <nz-form-label nzRequired nzFor="type">{{ 'servicenumber.type' | i18n }}</nz-form-label>
                        <nz-form-control [nzErrorTip]="'servicenumber.type-required' | i18n" [testId]="'servicenumber-type-control'">
                          <nz-select
                            formControlName="type"
                            id="type"
                            [nzPlaceHolder]="'servicenumber.type-placeholder' | i18n"
                            (ngModelChange)="onTypeChange($event)"
                            testId="servicenumber-detail-type-select"
                          >
                            <nz-option
                              *ngFor="let option of filteredTypeOptions; trackBy: trackByValue"
                              [nzValue]="option.value"
                              [nzLabel]="option.label"
                              [testId]="'servicenumber-type-option-' + option.value"
                            />
                          </nz-select>
                        </nz-form-control>
                      </nz-form-item>
                    </div>

                    <div nz-col [nzXs]="24" [nzSm]="12">
                      <nz-form-item [testId]="'servicenumber-open-type-form-item'">
                        <nz-form-label nzRequired nzFor="openType">{{ 'servicenumber.open-type' | i18n }}</nz-form-label>
                        <nz-form-control
                          [nzErrorTip]="'servicenumber.open-type-required' | i18n"
                          [testId]="'servicenumber-open-type-control'"
                        >
                          <nz-select
                            formControlName="openType"
                            id="openType"
                            [nzPlaceHolder]="'servicenumber.open-type-placeholder' | i18n"
                            [nzDisabled]="isOpenTypeDisabled"
                            testId="servicenumber-detail-open-type-select"
                          >
                            <nz-option
                              *ngFor="let option of openTypeOptions; trackBy: trackByValue"
                              [nzValue]="option.value"
                              [nzLabel]="option.label"
                              [testId]="'servicenumber-open-type-option-' + option.value"
                            />
                          </nz-select>
                        </nz-form-control>
                      </nz-form-item>
                    </div>

                    <div nz-col [nzXs]="24" [nzSm]="12">
                      <nz-form-item [testId]="'servicenumber-status-form-item'">
                        <nz-form-label nzRequired nzFor="status">{{ 'common.status' | i18n }}</nz-form-label>
                        <nz-form-control [nzErrorTip]="'common.status-required' | i18n" [testId]="'servicenumber-status-control'">
                          <nz-select
                            formControlName="status"
                            id="status"
                            [nzPlaceHolder]="'common.status-placeholder' | i18n"
                            testId="servicenumber-detail-status-select"
                          >
                            <nz-option
                              *ngFor="let option of statusOptions; trackBy: trackByValue"
                              [nzValue]="option.value"
                              [nzLabel]="option.label"
                              [testId]="'servicenumber-status-option-' + option.value"
                            />
                          </nz-select>
                        </nz-form-control>
                      </nz-form-item>
                    </div>

                    <div nz-col [nzSpan]="24" [testId]="'servicenumber-detail-description-col'">
                      <nz-form-item [testId]="'servicenumber-description-form-item'">
                        <nz-form-label nzRequired nzFor="description" [testId]="'servicenumber-detail-description-label'">{{
                          'common.description' | i18n
                        }}</nz-form-label>
                        <nz-form-control [nzErrorTip]="'common.description-required' | i18n" [testId]="'servicenumber-description-control'">
                          <textarea
                            nz-input
                            formControlName="description"
                            id="description"
                            [placeholder]="'common.description-placeholder' | i18n"
                            [nzAutosize]="{ minRows: 2, maxRows: 4 }"
                            [testId]="'servicenumber-detail-description-input'"
                          ></textarea>
                        </nz-form-control>
                      </nz-form-item>
                    </div>

                    <div nz-col [nzSpan]="24" *ngIf="isAdd">
                      <!-- 优化头像上传部分 -->
                      <!-- 优化头像上传部分 -->
                      <div nz-form-item>
                        <nz-form-label nzRequired>{{ 'servicenumber.avatar' | i18n }}</nz-form-label>
                        <nz-form-control [nzErrorTip]="'servicenumber.avatar-required' | i18n">
                          <div class="avatar-container">
                            <div class="avatar-wrapper" *ngIf="basicForm?.get('avatarUrl')?.value">
                              <img [src]="basicForm.get('avatarUrl')?.value" class="avatar-preview" />
                              <div
                                class="avatar-upload-btn"
                                (click)="showAvatarUploadModal()"
                                nz-tooltip
                                [nzTooltipTitle]="'servicenumber.change-avatar' | i18n"
                              >
                                <i nz-icon nzType="camera" nzTheme="outline" [testId]="'avatar-camera-icon'"></i>
                              </div>
                            </div>
                            <div class="avatar-wrapper" *ngIf="!basicForm?.get('avatarUrl')?.value">
                              <div class="avatar-placeholder">
                                <i nz-icon nzType="user" nzTheme="outline" [testId]="'avatar-user-icon'"></i>
                              </div>
                              <div
                                class="avatar-upload-btn"
                                (click)="showAvatarUploadModal()"
                                nz-tooltip
                                [nzTooltipTitle]="'servicenumber.upload-avatar' | i18n"
                              >
                                <i nz-icon nzType="camera" nzTheme="outline" [testId]="'avatar-placeholder-camera-icon'"></i>
                              </div>
                            </div>
                            <div class="avatar-hint">{{ 'servicenumber.avatar-hint' | i18n }}</div>
                          </div>
                        </nz-form-control>
                      </div>
                    </div>
                  </div>
                </nz-card>
              </form>
              <div class="member-card">
                <servicenumber-member
                  [serviceNumberId]="serviceNumberId"
                  [isAddSN]="isAdd"
                  [tenantId]="tenantId"
                  [tenantType]="tenantType"
                  (membersChange)="handleMembersChange($event)"
                  [testId]="'servicenumber-detail-member-component'"
                />
              </div>
            </div>
          </nz-tab>
          <nz-tab [nzTitle]="serviceSettingTitle" [nzDisabled]="isAdd" [testId]="'servicenumber-detail-service-tab'">
            <ng-template #serviceSettingTitle>
              <i nz-icon nzType="setting" nzTheme="outline" [testId]="'service-setting-icon'"></i>
              {{ 'servicenumber.service-setting' | i18n }}
            </ng-template>
            <servicenumber-config
              *ngIf="isTabActive('config')"
              [serviceNumberId]="serviceNumberId"
              [serviceNumberType]="basicForm.get('type')?.value"
              [tenantType]="tenantType"
              [embeddedInDetail]="true"
              #serviceNumberConfig
              [testId]="'servicenumber-detail-config-component'"
            />
          </nz-tab>

          <nz-tab [nzTitle]="robotTitle" [nzDisabled]="isAdd" [testId]="'servicenumber-detail-robot-tab'">
            <ng-template #robotTitle>
              <i nz-icon nzType="robot" nzTheme="outline" [testId]="'robot-setting-icon'"></i> {{ 'servicenumber.robot-setting' | i18n }}
            </ng-template>
            <personal-robot-setting
              *ngIf="isTabActive('robot')"
              [tenantIdInput]="tenantId"
              [serviceNumberIdInput]="serviceNumberId"
              [serviceNumberTypeInput]="basicForm.get('type')?.value"
              [serviceNumberNameInput]="serviceNumberName"
              [testId]="'servicenumber-detail-personal-robot-embedded'"
            />
          </nz-tab>

          <nz-tab
            *ngIf="shouldShowBroadcastTab()"
            [nzTitle]="broadcastTitle"
            [nzDisabled]="isAdd"
            [testId]="'servicenumber-detail-broadcast-tab'"
          >
            <ng-template #broadcastTitle>
              <i nz-icon nzType="notification" nzTheme="outline"></i> {{ 'personal-broadcast.list.title' | i18n }}
            </ng-template>
            <personal-broadcast-list
              *ngIf="isTabActive('broadcast')"
              [tenantIdInput]="serviceNumberId"
              [serviceNumberIdInput]="serviceNumberId"
              [serviceNumberOpenTypeInput]="basicForm.get('openType')?.value"
              [embedded]="true"
              [testId]="'servicenumber-detail-broadcast-component'"
            />
          </nz-tab>
          <nz-tab
            *ngIf="shouldShowInboundReasonTab()"
            [nzTitle]="inboundReasonTitle"
            [nzDisabled]="isAdd"
            [testId]="'servicenumber-detail-inbound-reason-tab'"
          >
            <ng-template #inboundReasonTitle>
              <i nz-icon nzType="question-circle" nzTheme="outline"></i> {{ 'servicenumber.inbound-reason.title' | i18n }}
            </ng-template>
            <personal-inbound-reason
              *ngIf="isTabActive('inbound-reason')"
              [tenantIdInput]="tenantId"
              [serviceNumberIdInput]="serviceNumberId"
              [embedded]="true"
              [testId]="'servicenumber-detail-inbound-reason-component'"
            />
          </nz-tab>

          <nz-tab *ngIf="isExternal()" [nzTitle]="channelTitle" [nzDisabled]="isAdd" [testId]="'servicenumber-detail-channel-tab'">
            <ng-template #channelTitle>
              <i nz-icon nzType="api" nzTheme="outline" [testId]="'channel-info-icon'"></i> {{ 'servicenumber.channel-info' | i18n }}
            </ng-template>
            <servicenumber-channel
              *ngIf="isTabActive('channel')"
              [serviceNumberId]="serviceNumberId"
              [testId]="'servicenumber-detail-channel-component'"
            />
          </nz-tab>

          <nz-tab
            *ngIf="isExternal() && isBoss() && serviceNumberId"
            [nzTitle]="identityTitle"
            [nzDisabled]="isAdd"
            [testId]="'servicenumber-detail-identity-tab'"
          >
            <ng-template #identityTitle>
              <i nz-icon nzType="team" nzTheme="outline" [testId]="'service-identity-icon'"></i>
              {{ 'servicenumber.service-identity' | i18n }}
            </ng-template>
            <identity-list
              *ngIf="isTabActive('identity')"
              [serviceNumberId]="serviceNumberId"
              [testId]="'servicenumber-detail-identity-component'"
            />
          </nz-tab>
          <nz-tab
            *ngIf="isExternal() && shouldShowAuthTab()"
            [nzTitle]="authTitle"
            [nzDisabled]="isAdd"
            [testId]="'servicenumber-detail-auth-tab'"
          >
            <ng-template #authTitle>
              <i nz-icon nzType="safety-certificate" nzTheme="outline" [testId]="'auth-management-icon'"></i>
              {{ 'servicenumber.auth.title' | i18n }}
            </ng-template>
            <servicenumber-auth
              *ngIf="isTabActive('auth')"
              [serviceNumberId]="serviceNumberId"
              [serviceNumberName]="serviceNumberName"
              [capabilityEnabled]="shouldShowAuthTab()"
              [testId]="'servicenumber-detail-auth-component'"
            />
          </nz-tab>
          <nz-tab *ngIf="isExternal()" [nzTitle]="webchatTitle" [nzDisabled]="isAdd" [testId]="'servicenumber-detail-webchat-tab'">
            <ng-template #webchatTitle>
              <i nz-icon nzType="message" nzTheme="outline" [testId]="'webchat-setting-icon'"></i>
              {{ 'servicenumber.webchat.title' | i18n }}
            </ng-template>
            <personal-webchat-setting
              *ngIf="isTabActive('webchat')"
              #embeddedWebchatSetting
              [tenantIdInput]="tenantId"
              [serviceNumberIdInput]="serviceNumberId"
              [serviceNumberAvatarUrl]="avatarUrl"
              [testId]="'servicenumber-detail-personal-webchat-embedded'"
            />
          </nz-tab>
          <!-- 對話匯出 -->
          <nz-tab *ngIf="canManageChatExport()" [nzTitle]="chatExportTitle" [testId]="'servicenumber-detail-chat-export-tab'">
            <ng-template #chatExportTitle>
              <i nz-icon nzType="export" nzTheme="outline" [testId]="'chat-export-icon'"></i>
              {{ 'servicenumber.chat-export.tab-title' | i18n }}
            </ng-template>
            <servicenumber-chat-export
              *ngIf="isTabActive('chat-export')"
              [serviceNumberId]="serviceNumberId"
              [serviceNumberName]="serviceNumberName"
              [serviceNumberType]="basicForm.get('type')?.value"
              [testId]="'servicenumber-detail-chat-export-component'"
            />
          </nz-tab>
          <!-- 将主题设置标签移动到最后 -->
          <nz-tab *ngIf="shouldShowThemeTab()" [nzTitle]="themeTitle" [testId]="'servicenumber-detail-theme-tab'">
            <ng-template #themeTitle>
              <i nz-icon nzType="bg-colors" nzTheme="outline" [testId]="'theme-setting-icon'"></i>
              {{ 'servicenumber.theme-setting' | i18n }}
            </ng-template>
            <servicenumber-theme
              *ngIf="isTabActive('theme')"
              [serviceNumberId]="serviceNumberId"
              [serviceNumberType]="basicForm.get('type')?.value"
              [tenantType]="tenantType"
              [testId]="'servicenumber-detail-theme-component'"
            />
          </nz-tab>
        </nz-tabset>

        <div class="mobile-desktop-mask" *ngIf="showMobileDesktopPrompt" [testId]="'servicenumber-detail-mobile-mask'">
          <div class="mobile-desktop-mask-backdrop"></div>
          <div class="mobile-desktop-mask-dialog">
            <div class="mobile-desktop-mask-icon">
              <i nz-icon nzType="desktop" nzTheme="outline"></i>
            </div>
            <div class="mobile-desktop-mask-title">{{ 'servicenumber.webchat.mobilePrompt.title' | i18n }}</div>
            <div class="mobile-desktop-mask-desc">{{ 'servicenumber.webchat.mobilePrompt.desc' | i18n }}</div>
            <div class="mobile-desktop-mask-actions">
              <button
                nz-button
                nzType="primary"
                class="mobile-desktop-mask-btn"
                (click)="dismissMobileDesktopPrompt()"
                testId="servicenumber-detail-mobile-prompt-close-button"
              >
                {{ 'common.close' | i18n }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </nz-spin>
  </div>
</ng-template>

<avatar-upload-modal
  [(visible)]="isAvatarModalVisible"
  [title]="'servicenumber.upload-avatar-title' | i18n"
  [uploading]="isAvatarUploading"
  [aspectRatio]="1"
  [resizeToWidth]="300"
  (cancel)="handleAvatarModalCancel()"
  (ok)="handleAvatarCropped($event)"
/>
<image-viewer
  [(visible)]="imageViewerVisible"
  [imageUrl]="avatarUrl"
  [title]="'common.image-preview' | i18n"
  (close)="closeImageViewer()"
/>
